// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__x36yT","errorLogs":"EditorFooter_errorLogs__1tRYW"};